import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Close = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Close({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.9394 12L4.32328 5.38388C4.12802 5.18862 4.12802 4.87203 4.32328 4.67677L4.67683 4.32322C4.8721 4.12796 5.18868 4.12796 5.38394 4.32322L12.0001 10.9393L18.6162 4.32322C18.8114 4.12796 19.128 4.12796 19.3233 4.32322L19.6768 4.67677C19.8721 4.87203 19.8721 5.18862 19.6768 5.38388L13.0607 12L19.6768 18.6161C19.8721 18.8114 19.8721 19.128 19.6768 19.3232L19.3233 19.6768C19.128 19.872 18.8114 19.872 18.6162 19.6768L12.0001 13.0607L5.38394 19.6768C5.18868 19.872 4.8721 19.872 4.67683 19.6768L4.32328 19.3232C4.12802 19.128 4.12802 18.8114 4.32328 18.6161L10.9394 12Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'close-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Close;
